import React, { useRef, useState } from 'react'
import './contact.style.css'
import { MdOutlineMail } from 'react-icons/md'
import { BsWhatsapp } from 'react-icons/bs'
import emailjs from 'emailjs-com'
import { toast } from 'react-toastify'

const Contact = () => {
  const form = useRef()
  const [loading, setLoading] = useState(false)
  const [subject, setSubject] = useState('')
  const [email, setEmail] = useState('')
  const [name, setName] = useState('')
  const [message, setMessage] = useState('')
  const sendEmail = (e) => {
    try {
      e.preventDefault()
      setLoading(true)
      emailjs
        .sendForm(
          'service_itslik4',
          'template_svg435j',
          form.current,
          'Lrv5MuqV2_XlusxGu'
        )
        .then(
          (result) => {
            setLoading(true)
            toast.success(
              'Thanks! Email has been sent successfully, will get in touch soon...'
            )
            setName('')
            setEmail('')
            setSubject('')
            setMessage('')
            setLoading(false)
          },
          (error) => {
            toast.error('aw snap ! Something Went Wrong, please Try Again !')
            console.log(error.text)
            setLoading(false)
          }
        )
    } catch (error) {
      console.log(error)
      toast.error('aw snap ! Something Went Wrong, please Try Again !')
      setLoading(false)
    }
  }

  return (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact_container">
        <div className="contact_options">
          <article className="contact_option">
            <MdOutlineMail className="contact_option_icon" />
            <h4>Email</h4>
            <h5>vivek.padelkar@gmail.com</h5>
            <a href="mailto:vivek.padelkar@gmail.com" target="_blank">
              Send a message
            </a>
          </article>

          <article className="contact_option">
            <BsWhatsapp className="contact_option_icon" />
            <h4>WhatsApp</h4>
            <h5>+91 7666918811</h5>
            <a
              href="https://api.whatsapp.com/send?phone=+917666918811"
              target="_blank"
            >
              Send a message
            </a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input
            type="text"
            name="email"
            placeholder="Your Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="text"
            name="subject"
            placeholder="Your Subject Line"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            required
          />
          <input
            type="text"
            name="name"
            placeholder="Your Full Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <textarea
            rows={7}
            type="text"
            name="message"
            placeholder="Your Message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />
          <div className="send_email_btn_container">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading ? true : false}
            >
              Send Message
            </button>
          </div>
        </form>
      </div>
    </section>
  )
}

export default Contact
